import { render, staticRenderFns } from "./vPaymentMethods.vue?vue&type=template&id=2768931e&scoped=true"
import script from "./vPaymentMethods.vue?vue&type=script&setup=true&lang=ts"
export * from "./vPaymentMethods.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vPaymentMethods.vue?vue&type=style&index=0&id=2768931e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768931e",
  null
  
)

export default component.exports